import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import AdminMenuWrapper from '@admin/nav_menu/AdminMenuWrapper';
import { Switcher, BasicButton } from '@components';
import styles from './QuoteHome.module.css';
import QuoteObject from '@quotes/QuoteObject';
import CreateEditQuote from '@quotes/CreateEditQuote';
import LoadingWrapper from '@components/LoadingWrapper';
import {
  getQuotes,
  addQuote
} from '@actions';

const QuoteHome = ({
  quoteInfo,
  getQuotes,
  addQuote
}) => {
  console.log("quote info", quoteInfo);

  const [viewingRich, setViewingRich] = useState(true);
  const [editingQuote, setEditingQuote] = useState(null);
  const [showQuoteModal, setShowQuoteModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);


  useEffect(() => {
    getQuotes(() => setIsLoading(false));
  }, []);

  const getQuoteObject = (quote) => {
    return (
      <QuoteObject
        key={quote.id}
        quote={quote}
        onEdit={() => {
          setEditingQuote(quote);
          setShowQuoteModal(true);
        }}
      />
    )
  }

  const quoteList = () => {
    if (viewingRich) {
      return quoteInfo.richQuotes.map((quote) => {
        return getQuoteObject(quote);
      })
    } else {
      return quoteInfo.otherQuotes.map((quote) => {
        return getQuoteObject(quote);
      })
    }
  }

  const getRichString = () => {
    if (quoteInfo.richQuotes.length === 0) {
      return "Rich Quotes";
    } else {
      return `Rich Quotes (${quoteInfo.richQuotes.length})`;
    }
  }

  const getFamousString = () => {
    if (quoteInfo.otherQuotes.length === 0) {
      return "Famous Quotes";
    } else {
      return `Famous Quotes (${quoteInfo.otherQuotes.length})`;
    }
  }

  const onAddQuote = (quoteInfo) => {
    addQuote(quoteInfo, () => {

    });
  };

  const onEditQuote = (quoteInfo) => {

  };

  return (
    <AdminMenuWrapper>
      <LoadingWrapper isLoading={isLoading} loadingText="Fetching Quotes" size="large">
        <div className={styles.quote_container_style}>
          <div className={styles.header_container}>
            <Switcher
              options={[getRichString(), getFamousString()]}
              onSelectOption={(option) => {
                setViewingRich(option === getRichString());
              }}
              selectedOption={viewingRich ? getRichString() : getFamousString()}
            />
            <div className={styles.quote_button}>
              <BasicButton
                text="Add Quote"
                type="primary"
                onClick={() => {
                  setEditingQuote(null);
                  setShowQuoteModal(true);
                }}
                style={{ width: "100% "}}
              />
            </div>
          </div>

          <div style={{ paddingTop: "20px "}}>
            {quoteList()}
          </div>
        </div>

        <CreateEditQuote
          isEdit={editingQuote != null}
          visible={showQuoteModal}
          quote={editingQuote}
          onCancel={() => setShowQuoteModal(false)}
          onAddQuote={(quoteInfo) => onAddQuote(quoteInfo)}
        />
      </LoadingWrapper>
    </AdminMenuWrapper>
  );
};

const mapStatesToProps = (state) => {
  const { quoteInfo } = state.quotes;
  return { quoteInfo };
};

export default connect(mapStatesToProps, {
  getQuotes,
  addQuote
})(QuoteHome);
